<template>
    <div class="input-container user-note">
        <textarea v-model="value"
                  :placeholder="translate('comment_note')"
                  :disabled="!isEditable">
        </textarea>
    </div>
</template>

<script>
    export default {
        name: "inputNote",
        props: ['title', 'placeholder', 'name'],
        data() {
            return {
                value: '',
            }
        },

        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            emitValidateData() {
                this.$parent.$emit('validateData', {
                    title: this.name,
                    isIncorect: false,
                    value: this.value,
                });
            }
        },

        computed: {
            isEditable() {
                return this.$store.getters.isOfferEditable;
            }
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });

            if (this.$store.state.productCard.custom.summary_form[this.name] !== undefined) {
                this.value = this.$store.state.productCard.custom.summary_form[this.name].value;
            }
        }
    }
</script>